import {
  gspx,
  GPX_EVENT_TYPES,
  GPX_FEATURES,
  GPX_CAPABILITIES,
  GPX_ROUTES,
} from '@rsos/gainsight';

const ALERT_TOASTS_EVENT_NAMES = {
  TOGGLE_ALERTS_TOASTS: 'alert_toasts_notifications_turned',
};

export const trackToggleAlertsToastsOnOff = (irpVersion, alertsToastsOn) => {
  const toggleStatus = alertsToastsOn ? 'On' : 'Off';
  gspx.trackEvent({
    name: ALERT_TOASTS_EVENT_NAMES.TOGGLE_ALERTS_TOASTS,
    type: GPX_EVENT_TYPES.INFO,
    feature: GPX_FEATURES.LEGACY,
    capability: GPX_CAPABILITIES.LEGACY,
    route: GPX_ROUTES.ADMIN,
    additionalKeys: {
      legacy_category: 'Admin',
      legacy_name: `Alert Toasts Notifications were turned ${toggleStatus}`,
      Category: 'Admin Settings',
      'Launched date': new Date(),
      irpVersion,
    },
  });
};
